import { render } from "./BillPay.vue?vue&type=template&id=0b96bf6a"
import script from "./BillPay.vue?vue&type=script&lang=js"
export * from "./BillPay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__